import * as _ from 'underscore';
import { STATIC_FILTERS } from '../../data-services/filter.service';
import { FieldType } from '../../shared/data-filter/field-type';
import { FilterGroup, FilterGroupSet } from '../../shared/data-filter/filter';
import { OPERATORS } from '../../shared/data-filter/filter-operators';
import { RsqlEncoder } from '../../shared/data-filter/rsql-encoder';
import { PortalUser } from '../../shared/domain/user';
import { TaskStage } from '../../shared/enums/task-stage';
import { TaskStatus } from '../../shared/enums/task-status';

export const TASK_FILTER_ON_TRACK: FilterGroup = {
  name: 'On Track',
  filters: [
    {
      name: 'On Track',
      field: 'status',
      type: FieldType.String,
      operator: OPERATORS.common.$eq,
      value: TaskStatus.OnTrack
    }
  ],
  category: 'status'
};

export const TASK_FILTER_OVERDUE: FilterGroup = {
  name: 'Overdue',
  filters: [
    {
      name: 'Overdue',
      field: 'status',
      type: FieldType.String,
      operator: OPERATORS.common.$eq,
      value: TaskStatus.Overdue
    }
  ],
  category: 'status'
};

export const TASK_FILTER_DELAYED: FilterGroup = {
  name: 'Delayed',
  filters: [
    {
      name: 'Delayed',
      field: 'status',
      type: FieldType.String,
      operator: OPERATORS.common.$eq,
      value: TaskStatus.Late
    }
  ],
  category: 'status'
};

export const TASK_FILTER_COMPLETE: FilterGroup = {
  name: 'Complete',
  filters: [
    {
      name: 'Complete',
      field: 'status',
      type: FieldType.String,
      operator: OPERATORS.common.$eq,
      value: TaskStatus.Complete
    }
  ],
  category: 'status'
};

export const TASK_FILTER_ON_HOLD: FilterGroup = {
  name: 'On Hold',
  filters: [
    {
      name: 'On Hold',
      field: 'status',
      type: FieldType.String,
      operator: OPERATORS.common.$eq,
      value: TaskStatus.OnHold
    }
  ],
  category: 'status'
};

export const TASK_FILTER_CANCELLED: FilterGroup = {
  name: 'Cancelled',
  filters: [
    {
      name: 'CANCELLED',
      field: 'status',
      type: FieldType.String,
      operator: OPERATORS.common.$eq,
      value: TaskStatus.Cancelled
    }
  ],
  category: 'status'
};

export const TASK_FILTER_NEEDS_ACTION: FilterGroup = {
  name: 'Needs Action',
  filters: [
    {
      name: 'Needs Action',
      field: 'needsAction',
      type: FieldType.Boolean,
      operator: OPERATORS.common.$eq,
      value: true
    }
  ],
  category: 'additional',
};

export const TASK_FILTER_READY_TO_START: FilterGroup = {
  name: 'Ready to Start',
  filters: [
    {
      name: 'Ready to Start',
      field: 'taskStageString',
      type: FieldType.String,
      operator: OPERATORS.common.$in,
      value: [TaskStage.ReadyToStart, TaskStage.InProgress]
    }
  ],
  category: 'additional'
};

export function getFilterGroups(): FilterGroup[] {
  return [
    TASK_FILTER_ON_TRACK,
    TASK_FILTER_OVERDUE,
    TASK_FILTER_DELAYED,
    TASK_FILTER_COMPLETE,
    TASK_FILTER_ON_HOLD,
    TASK_FILTER_CANCELLED,
    TASK_FILTER_NEEDS_ACTION,
  ];
}

export function getFilterGroupSets(): FilterGroupSet[] {
  return [{
    name: 'Active',
    filters: [
      { name: 'On Track' },
      { name: 'Overdue' },
      { name: 'Delayed' },
      { name: 'On Hold' },
      { name: 'Needs Action' },
    ],
    default: true
  },
  {
    name: 'All Tasks',
    filters: []
  }];
}


export function getTasksOverviewDefaultQuery(user: PortalUser, filterId?: number): string {
  const encoder = new RsqlEncoder();

  const defaultQuery1 = encoder.encodeGroup([
    {
      field: 'vendorAcceptanceDate',
      operator: OPERATORS.common.$isnull,
      value: true,
      type: FieldType.Boolean
    },
    {
      field: 'serviceString',
      operator: OPERATORS.common.$neq,
      value: 'FILING',
      type: FieldType.String
    },
    {
      field: 'serviceComponentId',
      operator: OPERATORS.common.$isnull,
      value: false,
      type: FieldType.Boolean
    }
  ], 'or');

  const defaultQuery2 = encoder.encodeGroup([
    {
      field: 'split',
      operator: OPERATORS.common.$eq,
      value: false,
      type: FieldType.Boolean
    },
    {
      field: 'parentTask',
      operator: OPERATORS.common.$eq,
      value: false,
      type: FieldType.Boolean
    }
  ], 'or');

  let vendorQuery = '';
  if (user.userType === 'VENDOR') {
    vendorQuery = encoder.encode({
      field: 'taskStageString',
      operator: OPERATORS.common.$neq,
      value: TaskStage.Requested,
      type: FieldType.String
    });
  }

  const defaultQueryExceptions = [
    STATIC_FILTERS.PMDashboardTasksQAReady,
    STATIC_FILTERS.PMDashboardTasksProjectLevelAssigned
  ];
  if (_.contains(defaultQueryExceptions, filterId)) {
    return vendorQuery;
  }

  return RsqlEncoder.combine([defaultQuery1, defaultQuery2, vendorQuery]);
}
